import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import Login from './pages/Login'
import Entry from './pages/Entry'
import Dashboard from './pages/Dashboard'
import Leads from './pages/Leads'
import Pipeline from './pages/Pipeline'
import Communications from './pages/Communications'
import Workflows from './pages/Workflows'
import SuperAdmin from './pages/SuperAdmin'
import MetaIntegration from './pages/Integrations/Meta'
import SecurityCenter from './pages/Admin/Security'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import AppShell from './components/layout/AppShell'

function App() {
  console.log("Spark CRM Portal: App Rendering");
  const { user, loading } = useAuth()

  if (loading) {
    return <div>Loading Spark CRM...</div>
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/entry" /> : <Login />} />
      <Route path="/entry" element={<Entry />} />
      <Route
        path="/"
        element={
          <ProtectedRoute permission="CRM_DASHBOARD_VIEW">
            <AppShell>
              <Dashboard />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/leads"
        element={
          <ProtectedRoute permission="CRM_LEAD_VIEW">
            <AppShell>
              <Leads />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/pipeline"
        element={
          <ProtectedRoute permission="CRM_PIPELINE_VIEW">
            <AppShell>
              <Pipeline />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/communications"
        element={
          <ProtectedRoute permission="COMM_HUB_VIEW">
            <AppShell>
              <Communications />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/workflows"
        element={
          <ProtectedRoute permission="AUTO_WORKFLOW_VIEW">
            <AppShell>
              <Workflows />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/integrations/meta"
        element={
          <ProtectedRoute permission="INT_META_VIEW">
            <AppShell>
              <MetaIntegration />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/security"
        element={
          <ProtectedRoute permission="SECURITY_CENTER_VIEW">
            <AppShell>
              <SecurityCenter />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/super-admin"
        element={
          <ProtectedRoute permission="SYS_ADMIN_ACCESS">
            <AppShell>
              <SuperAdmin />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute permission="ADMIN_ORG_MANAGE">
            <AppShell>
              <div>Settings Placeholder</div>
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route path="/unauthorized" element={<div>Unauthorized Access</div>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}

export default App

